import { render, staticRenderFns } from "./Dog-CoBreeder-comp.vue?vue&type=template&id=2a07d5cd&scoped=true&"
import script from "./Dog-CoBreeder-comp.vue?vue&type=script&lang=js&"
export * from "./Dog-CoBreeder-comp.vue?vue&type=script&lang=js&"
import style0 from "./Dog-CoBreeder-comp.vue?vue&type=style&index=0&id=2a07d5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07d5cd",
  null
  
)

export default component.exports